import { render, staticRenderFns } from "./SendImage.vue?vue&type=template&id=3734b9a0&scoped=true&"
import script from "./SendImage.vue?vue&type=script&lang=js&"
export * from "./SendImage.vue?vue&type=script&lang=js&"
import style0 from "./SendImage.vue?vue&type=style&index=0&id=3734b9a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3734b9a0",
  null
  
)

export default component.exports